// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "badge-1RJ6R";
var _3 = "clickable-1Y36Z";
var _4 = "invert-3N5oq";
var _5 = "badge__count-1BJGa";
export { _1 as "__esModule", _2 as "badge", _3 as "clickable", _4 as "invert", _5 as "badge__count" }
export default { "__esModule": _1, "badge": _2, "clickable": _3, "invert": _4, "badge__count": _5 }
